<app-template-radio [disabled]="disabled" [value]="value" [control]="control" [options]="options" [label]="label" />
